export var AiReviewNotificationEvent;
(function (AiReviewNotificationEvent) {
    AiReviewNotificationEvent["NeedsReview"] = "needs_review";
    AiReviewNotificationEvent["Assigned"] = "assigned";
})(AiReviewNotificationEvent || (AiReviewNotificationEvent = {}));
export var AiReviewNotificationChannel;
(function (AiReviewNotificationChannel) {
    AiReviewNotificationChannel["Bell"] = "bell";
    AiReviewNotificationChannel["SlackChannel"] = "slack_channel";
    AiReviewNotificationChannel["SlackDm"] = "slack_dm";
})(AiReviewNotificationChannel || (AiReviewNotificationChannel = {}));
export var AiReviewNotificationStatus;
(function (AiReviewNotificationStatus) {
    AiReviewNotificationStatus["Sent"] = "sent";
    AiReviewNotificationStatus["Errored"] = "errored";
    AiReviewNotificationStatus["Clicked"] = "clicked";
    AiReviewNotificationStatus["Dismissed"] = "dismissed";
})(AiReviewNotificationStatus || (AiReviewNotificationStatus = {}));
export const resolveAiReviewLinearDestination = ({ organizationUuid, projectUuid, applyToAllProjects, settings, destination, hasProjectDestinations, }) => {
    if (applyToAllProjects) {
        return {
            organizationUuid,
            projectUuid,
            enabled: settings.linearEnabled,
            linearTeamId: settings.linearTeamId,
            linearProjectId: settings.linearProjectId,
        };
    }
    if (destination) {
        return destination;
    }
    // Preserve routing configured before destinations became project-scoped.
    if (!hasProjectDestinations && settings.linearTeamId) {
        return {
            organizationUuid,
            projectUuid,
            enabled: settings.linearEnabled,
            linearTeamId: settings.linearTeamId,
            linearProjectId: settings.linearProjectId,
        };
    }
    return {
        organizationUuid,
        projectUuid,
        enabled: false,
        linearTeamId: null,
        linearProjectId: null,
    };
};
//# sourceMappingURL=aiReviewNotification.js.map